import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const Layout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Fecha o menu móvel sempre que se navega para outra página (ex.: depois de
  // tocar num link da sidebar), para não ficar aberto por cima do ecrã seguinte.
  React.useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-slate-50 dark:bg-[#0b0f1a] overflow-hidden transition-colors duration-300">
      <Topbar onMenuClick={() => setMobileMenuOpen(v => !v)} />
      <Sidebar isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
      <main className="flex-1 w-full min-w-0 overflow-x-hidden overflow-y-auto pt-20 px-4 sm:px-6 md:px-8 pb-8 custom-scrollbar">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
